import templateUrl from "emun.customer/customer-recommended-products.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";

export class CustomerRecommendedProductsController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.productImage = $ctrl.$appConfig.productImage.bind($ctrl.$appConfig);
    $ctrl.productViews = new AutoQuery({
      url: "QueryProductViews.json?dateRange=Last90",
      orderBy: "-LastViewed",
      autoLoad: true,
      pageSize: 10
    });
  }
}

export default {
  bindings: {
    customerId: "@"
  },
  controller: CustomerRecommendedProductsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
